// Good Friday dates (month is 1-indexed). Verified against published Easter Sunday
// dates; Good Friday is always 2 days before Easter Sunday.
// If you're having to update this list after 24 years - WOW! The system is still running. 😁
const GOOD_FRIDAY_DATES: Record<number, { month: number; day: number }> = {
  2020: { month: 4, day: 10 },
  2021: { month: 4, day: 2 },
  2022: { month: 4, day: 15 },
  2023: { month: 4, day: 7 },
  2024: { month: 3, day: 29 },
  2025: { month: 4, day: 18 },
  2026: { month: 4, day: 3 },
  2027: { month: 3, day: 26 },
  2028: { month: 4, day: 14 },
  2029: { month: 3, day: 30 },
  2030: { month: 4, day: 19 },
  2031: { month: 4, day: 11 },
  2032: { month: 3, day: 26 },
  2033: { month: 4, day: 15 },
  2034: { month: 4, day: 7 },
  2035: { month: 3, day: 23 },
  2036: { month: 4, day: 11 },
  2037: { month: 4, day: 3 },
  2038: { month: 4, day: 23 },
  2039: { month: 4, day: 8 },
  2040: { month: 3, day: 30 },
  2041: { month: 4, day: 19 },
  2042: { month: 4, day: 4 },
  2043: { month: 3, day: 27 },
  2044: { month: 4, day: 15 },
  2045: { month: 4, day: 7 },
  2046: { month: 3, day: 23 },
  2047: { month: 4, day: 12 },
  2048: { month: 4, day: 3 },
  2049: { month: 4, day: 16 },
  2050: { month: 4, day: 8 },
};

function goodFriday(year: number): Date | null {
  const entry = GOOD_FRIDAY_DATES[year];
  return entry ? new Date(year, entry.month - 1, entry.day) : null;
}

function nthWeekdayOfMonth(year: number, monthIndex: number, weekday: number, n: number): Date {
  const first = new Date(year, monthIndex, 1);
  const offset = (weekday - first.getDay() + 7) % 7;
  return new Date(year, monthIndex, 1 + offset + (n - 1) * 7);
}

function lastWeekdayOfMonth(year: number, monthIndex: number, weekday: number): Date {
  const last = new Date(year, monthIndex + 1, 0);
  const offset = (last.getDay() - weekday + 7) % 7;
  return new Date(year, monthIndex, last.getDate() - offset);
}

function observedFixedHoliday(year: number, monthIndex: number, day: number): Date {
  const date = new Date(year, monthIndex, day);
  const dow = date.getDay();
  if (dow === 0) {
    date.setDate(day + 1);
  } else if (dow === 6) {
    date.setDate(day - 1);
  }
  return date;
}

function toHolidayKey(date: Date): string {
  return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
}

function getUsMarketHolidays(year: number): Set<string> {
  const holidays: Date[] = [
    observedFixedHoliday(year, 0, 1),   // New Year's Day
    nthWeekdayOfMonth(year, 0, 1, 3),   // Martin Luther King Jr. Day
    nthWeekdayOfMonth(year, 1, 1, 3),   // Presidents' Day
    lastWeekdayOfMonth(year, 4, 1),      // Memorial Day
    observedFixedHoliday(year, 5, 19),   // Juneteenth
    observedFixedHoliday(year, 6, 4),    // Independence Day
    nthWeekdayOfMonth(year, 8, 1, 1),    // Labor Day
    nthWeekdayOfMonth(year, 10, 4, 4),   // Thanksgiving
    observedFixedHoliday(year, 11, 25),  // Christmas Day
  ];

  const easter = goodFriday(year);
  if (easter) {
    holidays.push(easter);
  }

  return new Set(holidays.map(toHolidayKey));
}

function isWeekend(date: Date): boolean {
  const dow = date.getDay();
  return dow === 0 || dow === 6;
}

function isMarketHoliday(date: Date): boolean {
  return getUsMarketHolidays(date.getFullYear()).has(toHolidayKey(date));
}

export default function useMtmDate(): Date {
  const previous = new Date();
  previous.setDate(previous.getDate() - 1);

  while (isWeekend(previous) || isMarketHoliday(previous)) {
    previous.setDate(previous.getDate() - 1);
  }

  return previous;
}
